import TileLayer from "ol/layer/Tile";
import {get as getProjection} from 'ol/proj'
import {getTopLeft, getWidth} from "ol/extent";
import {WMTS} from "ol/source";
import WMTSTileGrid from "ol/tilegrid/WMTS";
import {
    getLayerAttributes,
    getLayerNamePrefix,
    removeLoaderByBookmarkPresentationID
} from "@/helpers/ol/ol-layer-helper";
import {optionsFromCapabilities} from "ol/source/WMTS";
import {WMTSCapabilities} from "ol/format";
import TileGrid from "ol/tilegrid/TileGrid";
import proj4 from 'proj4';
import {getBySelector, showElementsBySelector} from "@/helpers/element-helper.js";
import {getRenderPixel} from "ol/render.js";
import Swipe from "ol-ext/control/Swipe.js";
import {loadFunction} from "@/modules/ol/service/ol-service-wms.js";
import {getViewProjection} from "@/helpers/ol/ol-projection-helper.js";
import {scaleToResolution} from "@/helpers/ol/view/ol-view-resolutation-helper.js";
import proj from "proj4/lib/Proj.js";
import {stopLadda} from "@/helpers/ladda-helper.js";

/**
 * Add Web Map Service
 * @param map
 * @param service
 */
export function addServiceWmts(map, service) {

    console.log('addddd')

    let serviceUrl = service.Url

    try {
        new URL(serviceUrl);

        serviceUrl = service.Url.slice(0, -1)
    } catch (_) {
        serviceUrl = window.kaartViewerUrl + serviceUrl
    }

    let matrixSet = service.Service.Projection

    let projection = getProjection(matrixSet);
    if(matrixSet === 'EPSG:28992') {
        projection.setExtent([-285401.92, 22598.080000000075, 595401.9199999999, 903401.92])
    }

    // For Belgium
    if(service.Service && service.Service.Projection === 'GoogleMapsVL') {
        matrixSet = 'GoogleMapsVL'
        projection = getProjection('EPSG:3857');
    }

    if(!projection) {
        // Get capabilities
        console.log('calling capabilities')
        loadWmts(service)
        return
    }

    if(!service.Opacity) {
        service.Opacity = 10
    }

    let sourceOptions = {
        url: serviceUrl,
        layer: service.Layer,
        matrixSet: matrixSet,
        format: 'image/png',
        projection: projection,
        tileGrid: new WMTSTileGrid(getTileGridByProjection(projection)),
        attributions: getLayerAttributes(service),
        style: ''
    }

    if(service.Url.includes('/map?')){
        sourceOptions.tileLoadFunction = (tile, src) => {
            loadFunction(tile, src)
        }
    }

    console.log(service)

    const layer = new TileLayer({
        opacity: service.Opacity / 10,
        minResolution: scaleToResolution(service.MinResolution),
        maxResolution: scaleToResolution(service.MaxResolution),
        zIndex: service.zIndex,
        minZoom:0,
        maxZoom:21,
        name: getLayerNamePrefix() + service.id,
        source: new WMTS(sourceOptions)
    })

    console.log(service.zIndex)

    window.map.addLayer(layer);

    removeLoaderByBookmarkPresentationID(service.id)

    return layer
}

export function addServiceWmtsWithOptions(id, layerName, matrixSet, result, service = undefined) {


    const options = optionsFromCapabilities(result, {
        layer: layerName,
        matrixSet: matrixSet,
    });

    console.log(service)

    const layer = new TileLayer({
        name: getLayerNamePrefix() + id,
        source: new WMTS(options),
        style: '',
        minResolution: scaleToResolution(service?.MinResolution),
        maxResolution: scaleToResolution(service?.MaxResolution),
        opacity: service?.Opacity / 10,
        zIndex: service?.zIndex,
    })

    console.log('add layer')

    window.map.addLayer(layer);

    return layer
}

export function getTileGridByProjection(projection) {

    const projectionExtent = projection.getExtent();
    const resolutions = new Array(20);
    const matrixIds = new Array(20);

    const size = getWidth(  projectionExtent ) / 256;

    for (let z = 0; z < resolutions.length; ++z) {
        resolutions[z] = size / Math.pow(2, z)
        matrixIds[z] = z
    }

    const origin = getTopLeft(projectionExtent)

    return {
        origin: origin,
        resolutions: resolutions,
        matrixIds: matrixIds
    }
}

export function getWmtsUrl(url) {
    url = url.replace('wfs', 'wms')

    if(url.endsWith('/')) {
        url = url.slice(0, -1)
    }

    if(!url.includes('?')) {
        url += '?'
    }
    if(!url.includes('service=')) {
        url += 'service=WMTS'
    }
    if(!url.includes('request=')) {
        url += '&request=GetCapabilities'
    }

    return url
}

export function loadWmts(service) {
    const url = getWmtsUrl(service.Url)

    fetch(url).then(response => {
        return response.text();
    }).then(result => {
        console.log(result)

        result = new WMTSCapabilities().read(result);

        let capability = result.Contents.Layer.find(layerContent => layerContent.Identifier === service.Layer)
        let matrixSet = capability.TileMatrixSetLink.find(layerContent => layerContent.TileMatrixSet === service.Service.Projection)

        if(!matrixSet) {
            matrixSet = capability.TileMatrixSetLink[0]
        }

        addServiceWmtsWithOptions(service.id, service.Layer, matrixSet, result, service)

        removeLoaderByBookmarkPresentationID(service.id)
    }).catch(error => {
    })
}